<template>
    <div class="modal__buttons__item w-auto px-3">
        <button type="button" style="border-top-right-radius: 0px; border-bottom-right-radius: 0px; padding-right:15px;" v-html="btn_label" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"/>
        <button type="button" class="dropdown-toggle dropdown-toggle-split ml-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="border-top-left-radius: 0px; border-bottom-left-radius: 0px; padding-right:0px;">
            <span class="sr-only"/>
        </button>
        <div class="dropdown-menu" :style="'font-size: 14px; padding:0; margin-top: 0px;'">
            <a class="dropdown-item" @click="downloadTxtFile()" v-html="'Download template file'"/>
            <a class="dropdown-item" v-html="'Upload File'" @click="show_input()"/>
        </div>
        <div v-show="false">
            <input
                type="file"
                ref="file_txt_input"
                :id="id"
                :class="'form-control'"
                style="height: 2rem; font-size:12px; color:black;"
                @change="file_upload($event)"
            />
        </div>
        
    </div>
</template>

<script>

const reader = new FileReader();
import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {
    name: 'UploadOptionsTXT',

    props: {
        empty_format_data: Array,
        excel_file_headers: Object,
        file_name: String,
        btn_label: {
            type: String,
            default: 'Upload options TXT'
        },
        id: {
            type: String,
            default: 'file_txt_input'
        },
    },

    data() {
        return {
            notyf,
        }
    },

    async created() {
    },
    
    methods: {
        show_input()
        {
            window.$(`#${this.id}`).click()
        },

        downloadTxtFile() {
            // Content of the text file
            const fileContent = "";

            // Create a Blob with the file content
            const blob = new Blob([fileContent], { type: "text/plain" });

            // Create a link element
            const link = document.createElement("a");

            // Set the href attribute to a data URL representing the Blob
            link.href = window.URL.createObjectURL(blob);

            // Set the download attribute to specify the filename
            link.download = `${this.file_name}.txt`;

            // Append the link to the document
            document.body.appendChild(link);

            // Trigger a click on the link to start the download
            link.click();

            // Remove the link from the document
            document.body.removeChild(link);
        },

        file_upload(event)
        {
            const file = event.target.files[0]
            if (file.type === 'txt' || file.type === 'text/plain')
            {
                reader.readAsBinaryString(file)
                reader.onload = (e) => 
                {
                    const content = e.target.result;

                    const lines = content.split('\n').map(line => line.trim())

                    const nonEmptyLines = lines.filter(line => line !== '')

                    this.$emit('data', nonEmptyLines)
                }
            }
            else 
            {
                this.notyf.error("The file is not compatible")
                return false
            }
        },

        clear_data()
        {
           this.$refs.file_txt_input.value = ""
        }

    },
    
}
</script>